import { render, staticRenderFns } from "./stop.vue?vue&type=template&id=7881d532&"
import script from "./stop.vue?vue&type=script&lang=js&"
export * from "./stop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7881d532')) {
      api.createRecord('7881d532', component.options)
    } else {
      api.reload('7881d532', component.options)
    }
    module.hot.accept("./stop.vue?vue&type=template&id=7881d532&", function () {
      api.rerender('7881d532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/stop.vue"
export default component.exports